import { TimeOccurrenceServant } from '../servants/time/time_occurrence_servant';
import { ITimeOccurrenceDatatype } from '../datastore/time/data_types';
import { IValidation } from './contracts';

angular
  .module('ui-ng-calendar')
  .factory('timeConfigValidator', function (ngTimeOccurrenceServant: TimeOccurrenceServant) {
    return function timeConfigValidator(store: ITimeOccurrenceDatatype[]): IValidation {
      let areTimeOccurrencesValid: boolean[] = _.map(store, (timeOccurrence: ITimeOccurrenceDatatype) => {
        return ngTimeOccurrenceServant.isTimeOccurrenceValid(timeOccurrence) || timeOccurrence.isLocked;
      });

      return {
        isValid: _.all(areTimeOccurrencesValid)
      };
    };
  });



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/validation/time_config_validator.ts